import { render, staticRenderFns } from "./ButtonPress.vue?vue&type=template&id=4ea73875&"
import script from "./ButtonPress.vue?vue&type=script&lang=js&"
export * from "./ButtonPress.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports